module.exports = {
  line_items: [
    {
      lead_times: [6],
      pricing   : [
        [0],
        [0],
        [0],
        [0],
      ],
      quantities: [4, 10, 50, 100],
    },
  ],
};
